<span class="context-toast --{{ type }} --{{ animation }}">
    <mat-icon>{{ type === "info" ? "check-circle" : "error" }}</mat-icon>
    <div class="context-toast__text">
        <h4 class="context-toast__text__title --s" [innerHTML]="title"></h4>
        <p class="context-toast__text__description --paragraph" [innerHTML]="message"></p>
    </div>
</span>
